// The public join page is the canonical entry for both new and existing accounts.
export function joinEntryTarget(search = '', storedCode = null) {
  const params = new URLSearchParams(search);
  const token = params.get('token')?.trim();
  if (token) return `/accept-invite?token=${encodeURIComponent(token)}`;
  let code = params.get('code');
  if (!code && storedCode) {
    try { code = JSON.parse(storedCode)?.code; } catch { /* old or blocked storage */ }
  }
  if (typeof code !== 'string') return '/join';
  code = code.trim().toUpperCase();
  return /^[A-Z0-9]{4,64}$/.test(code) ? `/join/${encodeURIComponent(code)}` : '/join';
}

export function joinCodeType(role) {
  if (role === 'assistant_coach' || role === 'coach') return 'coach';
  return role === 'parent' || role === 'player' ? role : null;
}

export function confirmedJoinToken(data, teamId) {
  if (!data || data.success !== true || data.team_id !== teamId ||
      typeof data.user?.id !== 'string' || !data.user.id.trim()) return null;
  const token = data.access_token || data.token;
  return typeof token === 'string' && token.trim() ? token : null;
}

export function uncertainJoinError(error) {
  const status = error?.response?.status;
  return !status || status === 408 || status >= 500;
}
